module.exports = __webpack_public_path__ + "img/mbh4.cce15b2a.jpg";